import { collection, doc, getFirestore, setDoc, Timestamp } from "firebase/firestore";
import { t } from "i18next";
import { Popup } from "../components/deprecated/Popup/Popup";
import { PopupTemplates } from "../components/deprecated/PopupTemplates/PopupTemplates";
import { LocalData } from "../to-be-removed/LocalData/General/LocalData";
import { PropertyData } from "../to-be-removed/LocalData/Property/PropertyData";
import { UnitData } from "../to-be-removed/LocalData/Property/Units/UnitData";
import { RoutineData } from "../to-be-removed/LocalData/Routines/RoutineData";
import { FirebaseEvents } from "./firebaseEvents";

import { ToastUtilities } from "../libs/react-toastify/ToastUtilities";
import { FirebaseFile } from "../to-be-removed/LocalData/General/FirebaseFile";
import { getSingularTenantUnitTitle } from "./data/roles.utils";

export class DataCreator {
  static createTenant(property: PropertyData, createdHandler: (tenant: UnitData) => void) {
    let unitTitle = getSingularTenantUnitTitle(undefined);
    PopupTemplates.presentTextInput({
      title: `${t("main.addNew")} ${unitTitle}`,
      placeholder: t("main.fillInName"),
      onConfirm: (popupId, name) => {
        Popup.remove(popupId);
        const db = getFirestore();
        const ref = doc(collection(db, "properties", property.id, "units"));

        ToastUtilities.presentSavingToast(
          setDoc(ref, {
            name: name,
            createdBy: DataCreator.getCreatedBy(),
          }).then(() => {
            let tenant = LocalData.getUnitWithId(ref.id);
            tenant.parent = property;
            tenant.property = property;
            tenant.loaded = true;
            tenant.name = name;
            property.units.push(tenant);

            createdHandler(tenant);
            FirebaseEvents.logEvent("tenant_created", {});
          })
        );
      },
      actionTitle: t("main.create"),
      dataCy: "create-new-tenant-name-input",
    });
  }

  static duplicateRoutine(routine: RoutineData, title: string, propertyIDs: string[] | undefined, successHandler: (routine: RoutineData) => void) {
    const db = getFirestore();
    const ref = doc(collection(db, "routines"));

    const promises: Promise<any>[] = [];
    const data: { [key: string]: any } = { ...routine.rawData, createdBy: this.getCreatedBy(), title: title, active: false };

    // Properties
    if (propertyIDs && propertyIDs.length > 0) {
      data.propertyIDs = {};
      for (const propertyID of propertyIDs) {
        data.propertyIDs[propertyID] = {};
      }
    }

    // Files
    delete data["files"];

    const files = routine.files;
    if (files.length > 0) {
      data.files = {};
      files.forEach((file) => {
        if (file.path) {
          const newFileData = file.getFirebaseMap();
          newFileData.path = file.path.replace("routines/" + routine.id, "routines/" + ref.id);
          const newFile = FirebaseFile.initialize(file.id, newFileData);
          promises.push(
            file
              .loadBlob()
              .then((blob) => {
                newFile.dataURL = file.fileURL;
                return new Promise((resolve) =>
                  newFile.saveImage(blob, (success) => {
                    if (success) {
                      data.files[file.id] = newFile.getFirebaseMap();
                    }
                    resolve(success);
                  })
                );
              })
              .catch((error) => {
                console.error("Error loading blob for file: " + error);
              })
          );
        }
      });
    }

    Promise.all(promises)
      .then(() => setDoc(ref, data))
      .then(() => {
        const report = LocalData.routines.addData(ref.id);
        report.setup(data);

        successHandler(report);
      })
      .catch((error) => {
        console.error("There was an error creating the routine: " + error.code + ", message: " + error.message + ", details: " + error.details);
      });
  }

  /**
   *
   * @deprecated use getCurrentUser hook to use userID
   */
  static getCreatedBy() {
    return {
      userID: LocalData.currentUser.id,
      date: Timestamp.fromDate(new Date()),
    };
  }
  static getUpdatedBy() {
    return {
      userID: LocalData.currentUser.id,
      date: Timestamp.fromDate(new Date()),
    };
  }
  static getDeletedBy() {
    return {
      userID: LocalData.currentUser.id,
      date: Timestamp.fromDate(new Date()),
    };
  }
}
